import configReducers from './config-slice';

export default {
  ...configReducers,
};

export * from './config-slice';
